<template>
  <div class="slider-container">
    <button
      @click="$emit('decrement')"
      class="button button--circle bolder left--button"
    >
      -
    </button>
    <span class="bolder slider-body">{{ thresholdFormatted }}</span>
    <button
      @click="$emit('increment')"
      class="button button--circle bold right--button"
    >
      +
    </button>
  </div>
</template>
<script>
import formatCurrency from '@/plugins/currency-formatter';
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    thresholdFormatted() {
      return formatCurrency(this.value, { includeZeros: false });
    },
  },
};
</script>
<style lang="scss" scoped>
.slider-container {
  position: relative;
  background-color: white;
  padding: 2rem;
  text-align: center;
  border-radius: 5px;
  font-weight: bold;
  width: calc(100% - 40px);
  margin: auto;
}
.slider-body {
  font-size: 225%;
}
.button {
  line-height: 40px;
  width: 45px;
  height: 45px;
  padding: 0;
  box-shadow: 0 0 3px 0 #000000;
  margin: 0;
  font-size: 150%;
}

.left--button {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
}
.right--button {
  position: absolute;
  top: 50%;
  right: 0;
  transform-origin: center;
  transform: translate(50%, -50%);
}
</style>
